import React, { useState, useEffect } from 'react';
import ScrollInfo from '../UI/ScrollInfo/ScrollInfo';
import classes from './Projects.module.scss';

import img1 from '../../assets/images/main page hover images/people of chennai.jpg';
import img2 from '../../assets/images/main page hover images/beauty and the beach.jpg';
import img3 from '../../assets/images/main page hover images/Jane in mahabs.jpg';
import img4 from '../../assets/images/main page hover images/Street Graffiti.jpg';
import img5 from '../../assets/images/main page hover images/Vinu sha.jpg';
import Gallery from './Gallery/Gallery';

const imagesData = [
  { src: img1, x: 60, y: -50, active: false, z: 0 },
  { src: img2, x: -80, y: -25, active: false, z: 0 },
  { src: img3, x: 35, y: -10, active: false, z: 0 },
  { src: img4, x: 50, y: 10, active: false, z: 0 },
  { src: img5, x: -40, y: 40, active: false, z: 0 },
];

const Projects = ({ maskSize, setMaskSize, isMobile  }) => {
  // const maskMinSize = Math.max(window.innerWidth * 0.06, 80);
  // const maskMaxSize = Math.min(window.innerWidth * 0.3, 400);

  const [images, setImages] = useState([]);
  // const [mousePos, setMousePos] = useState([0, 0]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [transX, setTransX] = useState(-1);

  // useEffect(()=> {
  //   let moveTimeout = true;
  //   const mouseMoveHandler = (e)=> {
  //     if (moveTimeout) {
        // const x = e.pageX;
        // const y = e.pageY;
        // setMousePos([x, y]);
  //       moveTimeout = false;
  //       setTimeout(()=> moveTimeout = true, 100);
  //     }
  //   };
  //   document.documentElement.addEventListener('mousemove', mouseMoveHandler);

  //   return ()=> {
  //     document.documentElement.removeEventListener('mousemove', mouseMoveHandler);
  //   }
  // }, []);

  // useEffect(()=> {
  //   setTransX(prevT => prevT === -1 ? 0 : 100);
  // }, [activeIndex]);

  useEffect(()=> {
    let timeout;
    if (images.length > 0 && !images[images.length-1].active)
      timeout = setTimeout(()=> {
        setImages(prevImages => {
          const newImages = [...prevImages];
          const len = prevImages.length;
          
          for (let i=len-1; i>=0; i--) {
            if(!newImages[i].active) {
              newImages[i] = {
                ...newImages[i],
                active: true
              };
            }
            else break;
          }
          return newImages;
        });
      }, 100);

    return ()=> clearTimeout(timeout);
  }, [images]);

  useEffect(()=> {
    if (transX > 50) {
      document.body.classList.add('scrollable');
      document.body.style = 'overflow: hidden';
    } 
    else {
      document.body.classList.remove('scrollable');
      document.body.style = 'overflow: auto';
    } 
  }, [transX]);

  const addImage = index => {

    setImages(prevImages => prevImages.concat({
      ...imagesData[index],
      z: prevImages.length,
      extras: (Math.random() * 20 - 10)
    }));
  };
  const openAlbum = index => {
    setActiveIndex(index);
    setTimeout(()=> setTransX(100), 100);
    // setTransX(100);
  };

  const contents = (
    <div className={classes.Contents} style={{
      transform: `translateX(-${transX}%)`
    }}
    >
      <div className={classes.FloatImages}
        // onClick={()=> setImages([])}
      >
        <div className={classes.Backdrop}
          onClick={()=> setImages([])}
        ></div>

        {images.map((img, i)=> {
          const styles = {
            zIndex: img.z,
            transform: 'translate(-50%, -50%)',
            opacity: 0
          };
          if (img.active) {
            styles.transform = `translate(${-50 + img.x + img.extras}%, ${-50 + img.y + img.extras}%)`;
            styles.opacity = 1;
          }
          return (
            <img key={i} src={img.src} alt="IMG" className={classes.FloatImage} style={styles} />
          );
        })}
        {/* {maxImagesArr.map(zIndex => 
          
        )} */}
      </div>

      <div className={classes.TextContents}>
        <p className={[classes.Text, classes.Text1].join(' ')}
          onMouseEnter={()=> addImage(0)}
          onClick={()=> openAlbum(0)}
        >People of Chennai</p>
        <div className={classes.TextDiv}>
          <p className={[classes.Text, classes.Text2].join(' ')}
            onMouseEnter={()=> addImage(1)}
            onClick={()=> openAlbum(1)}
          >Beauty & beach</p>
          <span>  street</span>
        </div>
        <p className={[classes.Text, classes.Text3].join(' ')}
          onMouseEnter={()=> addImage(2)}
          onClick={()=> openAlbum(2)}
        >Jane Thompson in Mahabalipuram</p>
        <p className={[classes.Text, classes.Text4].join(' ')}
          onMouseEnter={()=> addImage(3)}
          onClick={()=> openAlbum(3)}
        >Luzagrat's street & graffiti</p>
        <p className={[classes.Text, classes.Text5].join(' ')}
          onMouseEnter={()=> addImage(4)}
          onClick={()=> openAlbum(4)}
        >It's Vinu sha's dream...</p>
        <p className={[classes.Text, classes.Text6].join(' ')}>fashion</p>
      </div>

    </div>
  );

  return (
    <div className={classes.Projects}
      // onClick={()=> setImages([])}
    >
      {/* <ScrollInfo small={isMobile} parentClass={classes.Projects}>Photography</ScrollInfo> */}
      <ScrollInfo small={isMobile} parentClass={classes.Projects} 
        clicked={transX > 50 ? ()=> setTransX(0) : null}  
      >
        {transX < 50 ? "Photography" : "Go back to main page"}
      </ScrollInfo>

      {/* <div className={classes.Mask} style={{
        clipPath: `circle(${maskSize}px at ${mousePos[0]}px ${mousePos[1]}px)`
      }}>
        
      </div> */}

      {contents}

      <Gallery activeIndex={activeIndex} setActiveIndex={setActiveIndex} onBack={()=> setTransX(0)} style={{
        transform: `translateX(-${transX}%)`
      }} /> 

    </div>
  );
}

export default Projects;